import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { MaskedInput } from '../MaskedInput';
import { useToggleState } from '@cian/react-utils';

import * as styles from './styles.css';
import { Checkbox, UIHeading2, UIText1 } from '@cian/ui-kit';

export interface IForm {
  formTitle?: string;
  buttonTitle: string;
  error?: string;
  phone: string;
  loading: boolean;
  submitPhone(): void;
  setPhone(phone: string): void;
  setOpen(open: boolean): void;
}

export const Form: React.FC<IForm> = ({
  formTitle,
  buttonTitle,
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
}) => {
  const { state, toggle } = useToggleState(false);

  const onSubmit = React.useCallback(() => {
    submitPhone();
  }, [submitPhone]);

  const openModal = React.useCallback(
    (e: React.MouseEvent<HTMLSpanElement>) => {
      e.preventDefault();

      setOpen(true);
    },
    [setOpen],
  );

  return (
    <div className={styles['form']}>
      <div className={styles['title']}>
        <UIHeading2 fontWeight="700">{formTitle}</UIHeading2>
      </div>
      <div className={styles['input']}>
        <MaskedInput value={phone} invalid={Boolean(error)} onChange={setPhone} />
        {error && <span className={styles['error']}>{error}</span>}
      </div>
      <div className={styles['info']}>
        <UIText1>На телефон придёт код подтверждения. Циан никому не отдаст ваш номер, пока вы не разрешите.</UIText1>
      </div>
      <label className={styles['agreement']} data-name="AgreementCheckbox">
        <UIText1>
          Соглашаюсь на&nbsp;
          <span className={styles['agreement-link']} onClick={openModal} data-name="PersonalAgreement">
            обработку моих персональных данных
          </span>
        </UIText1>
        <div className={styles['checkbox']}>
          <Checkbox onChange={toggle} checked={state} />
        </div>
      </label>
      <div className={styles['button']} data-name="SubmitButton">
        <Button fullWidth size="L" loading={loading} onClick={onSubmit} disabled={!state}>
          {buttonTitle}
        </Button>
      </div>
    </div>
  );
};
